import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropDown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.2966 10.385L12.6028 14.718C12.2822 15.094 11.7165 15.094 11.396 14.718L7.70215 10.385C7.24452 9.847 7.61429 9 8.30652 9H15.6941C16.3864 9 16.7561 9.847 16.2966 10.385Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgArrowDropDown);
export default ForwardRef;
